import axios from 'axios';

const axiosClient = axios.create();

// Set token from storage on creation
const token = localStorage.getItem('TOKEN') || sessionStorage.getItem('TOKEN');
if (token) {
    axiosClient.defaults.headers.common['Authorization'] = `Token ${token}`;
}

// Response interceptor: handle 401 (expired/invalid token)
axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Don't redirect if already on sign-in page or if this is the sign-in request
            const isAuthRequest = error.config?.url?.includes('/rest-auth/login');
            if (!isAuthRequest) {
                localStorage.clear();
                sessionStorage.clear();
                localStorage.setItem('IS_AUTHENTICATED', 'false');
                window.location.href = '/accounts/signin?expired=1';
                return new Promise(() => {}); // prevent further .catch handling
            }
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
